import { useMutation } from '@apollo/client';

import CHECK_ANSWER_QUERY from 'graphql/gamification/mutations/checkAnswer.graphql';

import {
  CheckAnswerMutation,
  CheckAnswerMutationVariables,
  CheckAnswerInput,
} from 'graphql/types';

export const useCheckAnswer = () => {
  const [doCheckAnswer, { data, error }] = useMutation<
    CheckAnswerMutation,
    CheckAnswerMutationVariables
  >(CHECK_ANSWER_QUERY);

  const checkAnswer = async (input: CheckAnswerInput) => {
    await doCheckAnswer({
      variables: {
        input,
      },
      refetchQueries: ['GetDailyQuestionUserScore'],
    });
  };

  return {
    checkAnswer,
    data,
    error,
  };
};
